var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.useOldHome)?_c('v-btn',{on:{"click":_vm.toggleHome}},[_vm._v("Nueva vista")]):_c('v-btn',{on:{"click":_vm.toggleHome}},[_vm._v("Antigua vista")]),(_vm.useOldHome)?_c('Home'):_c('HomeOptimized')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }